
import { memo } from 'react';
import { formatDate } from 'utils/helpers'

function Item({ item }) {
  const { content, from_patient, time } = item?.attributes || {};
  const isRight = from_patient === true;

  return (
    <div className={`chat ${isRight ? 'chat-end' : 'chat-start'}`}>
      <div className={`chat-bubble relative max-w-[78%] pb-5 pr-14 text-sm leading-relaxed ${isRight ? 'chat-bubble-primary text-white' : 'bg-base-200 text-secondary-700'}`}>
        <span className="whitespace-pre-wrap break-words">{content}</span>
        <time className={`absolute bottom-1.5 right-3 text-[10px] leading-none ${isRight ? 'text-white/70' : 'text-secondary-400'}`}>
          {formatDate(time, 'twelveHour')}
        </time>
      </div>
    </div>
  );
}

export default memo(Item);
